import { createStore } from 'vuex'

export default createStore({
  state: {
//loggedin: false,
loggedin: true,
    userId: 0,
    theme: "mainCustomLightTheme",
//mainurl: 'https://isling.org:8000',
mainurl: 'https://isling.org',
//mainurl: 'https://kpabg.ru',

  cookies: document.cookie,
//cookies: "userData=%7B%22id%22%3A%2211%22%2C%22isadmin%22%3Atrue%2C%22locked%22%3Anull%2C%22username%22%3A%22MelechinA%22%2C%22foldername%22%3Anull%2C%22email%22%3A%22melihen%40yandex.ru%22%2C%22fullname%22%3A%22AdminL%22%2C%22about%22%3Anull%2C%22language%22%3A%22ru%22%2C%22source%22%3Anull%7D; VEE=wikitext",
// in production - delete fake cookies

rowsToPrint: [],
metaPrint: {columns:[]},
filtersPrint: {},
//    areacoordvalue: "'geotable:2171:4:geom'",
 //   theme: "myFishTheme",
    
//    pointfieldname: '',
//    themeColor: 'dark',
//    themeColor: 'light',
//    materialname: '',

//    tableId: 200, //таблица по-умолчанию для отрисовки страницы материала (если ссылка на материал "снаружи" - то используется общая таблица для образцов)


//    dataset_uri_sps: 'http://kpabg.ru:8000/dataset/list?f=198',
//    structure_sps: 'http://kpabg.ru:8000/dataset/list?f=100&f_id=198',

//    imgsrc: '',
//colors of parts
drawEnable: false,
// mounted(){

//   this.cookie = "123";
//   console.log(this.cookie);
//   },


 //   tableIdTo: null
  },
  getters: {
  },
  mutations: {

    getRowsToPrint(state, selectedRows){
      state.rowsToPrint = selectedRows;
//      console.log(state.rowsToPrint);

    },
    getMetaPrint(state, metatoptint){
      state.metaPrint = metatoptint;
//      console.log(state.metaPrint);
    },

    // getColumnPrint(state, columntoptint){
    //   state.columnPrint = columntoptint;
    //   console.log(state.columnPrint);
    // },
    
    getFilterstoprint(state, filtoptint){
      state.filtersPrint = filtoptint;
    },

    drawEnableDisable(state){
      state.drawEnable = !state.drawEnable;
    },

    getCookies(state){
      state.cookies = document.cookie;
    //  console.log('done', state.cookies)
    }

/*
    updatePoint(state, name){
      state.pointfieldname = name;
    },
*//*
    getTableIdToState(state){
      state.tableId = 200;
    },
*/
/*    
    getTableIdTo(state, tid){
    state.tableId = tid;
*/
    // если на материал переходишь из таблицы N - используется ид таблицы N (=tid - получаем как payload из BaseGeoTable)
/* Более подробно:
Откуда взялся tid? и что такое state? Это аргументы которые получают значения из метода (или хака - как в примере ниже):

    beforeUnmount(){
  this.$store.commit('getTableIdTo', this.meta.dataset_id); // где state = 'getTableIdTo', tid = this.meta.dataset_id
    },
*/
//    },
/*    
    getImgSrc(state, src){
      state.imgsrc = src;
      }, 
*/
  },
  actions: {
  },
  modules: {
  }
})

// косяк в том, что почему-то даже после обновления страницы материала tableId сбраcывается на умолчальный (2187).
